import { render } from "./FloatingImages.vue?vue&type=template&id=071f20f8"
import script from "./FloatingImages.vue?vue&type=script&lang=js"
export * from "./FloatingImages.vue?vue&type=script&lang=js"

import "./FloatingImages.vue?vue&type=style&index=0&id=071f20f8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__